import { DateTime } from 'luxon';
import { AlocacoesQuery_alocacoes_professores } from '../../graphql/queries/__generated__/AlocacoesQuery';

function mapear_alocacoes(alocacoes: AlocacoesQuery_alocacoes_professores[]) {
  const map = new Map<string, AlocacoesQuery_alocacoes_professores>();

  alocacoes.forEach((a) => {
    const chave = DateTime.fromISO(a.dat_alocacao, { setZone: true }).startOf('day').toISODate();
    map.set(chave, a);
  });

  return map;
}

export { mapear_alocacoes };
